const gradients = {
  restaurant: "from-pink-100 via-red-100 to-yellow-100",
  gym: "from-green-50 via-green-100 to-green-200",
  conference: "from-blue-100 via-indigo-100 to-purple-100",
  banquet: "from-purple-100 via-pink-100 to-red-100", // 🎉 new banquet gradient
  textile: "from-blue-50 via-blue-100 to-blue-200", // 🔵 for TextileShopProjects
  worship: "from-blue-50 via-blue-100 to-blue-200",  // 🙏 matches worship download button
  supermarket: "from-green-50 via-green-100 to-green-200", // 🛒 supermarket
 hospital: "from-teal-50 via-teal-100 to-teal-200",  // 🏥 hospital
 corporate:
    "bg-gradient-to-br from-blue-50 via-gray-100 to-blue-100",
 orange: "from-orange-50 via-orange-100 to-orange-200",
};

export default gradients;
